import React, { ComponentType } from 'react'

// TODO: add data-collapsed with isCollapsed prop if needed for livePreview

type Props = {
	id: string
}
const GhostRefComp: ComponentType<Props> = ({ id }) => {
	return (
		<div
			id={id}
			style={{
				visibility: 'hidden',
				overflow: 'hidden',
				width: 0,
				minWidth: 0,
				height: 0,
				minHeight: 0,
				pointerEvents: 'none',
				margin: 0,
			}}
		/>
	)
}

export default GhostRefComp
